/**
 * Descargas en curso (Mario, 4-nov: «al descargar archivos no se muestra un loading y el usuario no sabe que pasa»;
 * algunos Excel tardan decenas de segundos). Lógica pura, sin Angular: el servicio envuelve cada petición que
 * devuelve un archivo con `conLoading` y un indicador (app-descargas-en-curso) pinta lo que esté en curso.
 *
 * - Misma clave mientras sigue en curso: devuelve la MISMA promesa y no dispara otra petición. Varias descargas del
 *   núcleo guardan huella y marcan el estado DESCARGADO; un doble clic no debe duplicarlas.
 * - Al terminar, con éxito o con error, se retira siempre. El error llega igual al llamador (sus mensajes no cambian).
 * Catálogo: .scratch/liquidacion/pruebas.md, «Loading en las descargas» (DCG-01..10).
 */
const enCurso = new Map();
const oyentes: any = [];

/** Lo que se está preparando ahora, en el orden en que empezó. */
export const descargasEnCurso = (): any => Array.from(enCurso.values()).map((d) => ({ clave: d.clave, texto: d.texto }));

const avisar = (): any => { const lista = descargasEnCurso(); oyentes.slice().forEach((fn: any) => fn(lista)); };

/** Avisa la lista actual y cada cambio. Devuelve la función para darse de baja. */
export const alCambiarDescargas = (fn: any): any => {
  oyentes.push(fn);
  fn(descargasEnCurso());
  return () => { const i = oyentes.indexOf(fn); if (i >= 0) oyentes.splice(i, 1); };
};

/** Ejecuta `tarea` (que devuelve una promesa) y la mantiene a la vista mientras dure. */
export const conLoading = (clave: string, texto: string, tarea: any): any => {
  const previa = enCurso.get(clave);
  if (previa) return previa.promesa;
  let base;
  try { base = Promise.resolve(tarea()); } catch (e) { base = Promise.reject(e); }
  const promesa = base.finally(() => { enCurso.delete(clave); avisar(); });
  enCurso.set(clave, { clave, texto, promesa });
  avisar();
  return promesa;
};

const guardados = new WeakSet();
/** Dos llamadores de la misma descarga reciben el mismo archivo: true si ese archivo ya se guardó. */
export const archivoYaGuardado = (blob: any): any => {
  if (guardados.has(blob)) return true;
  guardados.add(blob);
  return false;
};
